import React, { memo } from 'react';
import {
  ActionsCell,
  OptionalDataCurrencyCell,
  OptionalDataInputCell,
} from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/cellCallbacks';
import BondNameCell from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/BondNameCell/BondNameCell';
import DatePurchasedCell from '../DatePurchasedCell';
import { IPosition } from '@/finsight/domain/vo/PortfolioMonitor/ICreatePortfolioFormState';
import { formatPositionSize } from '@/finsight/ui/components/portfolioMonitor/helpers';

import styles from '@/finsight/ui/components/portfolioMonitor/PortfolioContent/common/fieldRowStyles.scss';

interface IProps {
  data: IPosition,
  rowIndex: number,
}

const FieldRow = ({ data, rowIndex }: IProps) => {
  const { cusip, bond } = data;

  return (
    <div className={ styles.row } data-test="positionRow">
      <div className={ styles.cusip } data-test="cusip">
        { cusip || '-' }
      </div>
      <div className={ styles.deal }>
        <BondNameCell row={ data } />
      </div>
      <div className={ styles.currency }>
        <OptionalDataCurrencyCell
          rowIndex={ rowIndex }
          cellName="currencyId"
          isDisabled={ !!bond?.dealId }
        />
      </div>
      <div className={ styles.inputField }>
        <OptionalDataInputCell
          rowIndex={ rowIndex }
          cellName="positionSize"
          params={ { placeholder: '1,000,000' } }
          format={ formatPositionSize }
        />
      </div>
      <div className={ styles.inputField }>
        <OptionalDataInputCell
          rowIndex={ rowIndex }
          cellName="dollarPricePaid"
          params={ { placeholder: '100.00000' } }
          format={ (val) => val || '' }
        />
      </div>
      <div className={ styles.datePurchased }>
        <DatePurchasedCell cellName="datePurchased" rowIndex={ rowIndex } />
      </div>
      <div className={ styles.actionCell }>
        <ActionsCell rowIndex={ rowIndex } />
      </div>
    </div>
  );
};

export default memo(FieldRow);
